import { render } from "./oncology_prescriptions.vue?vue&type=template&id=07168318&scoped=true"
import script from "./oncology_prescriptions.vue?vue&type=script&lang=js"
export * from "./oncology_prescriptions.vue?vue&type=script&lang=js"

import "./oncology_prescriptions.vue?vue&type=style&index=0&id=07168318&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07168318"]])

export default __exports__